import { getRelatedMenuResourceList } from "../api/admin";
import { AC_MENU_EXPAND_PARENT_NAMES } from "../constants/acMenu";

type RelatedResourceResponse = { data?: string[] };

const asNameList = (res: RelatedResourceResponse | null | undefined): string[] =>
  Array.isArray(res?.data) ? res!.data!.filter(Boolean) : [];

/**
 * Layered menu privilege load (App bootstrap, before Router):
 * 1) parentId: 0 (root, includes view_admin_center)
 * 2) parentName: view_admin_center
 * 3) expand nested parents (operate_uam, view_process_manager, …)
 */
export async function fetchLayeredMenuPrivilege(
  userId: string
): Promise<string[]> {
  const base = {
    userId,
    resourceType: "",
    app: "",
    module: "",
    subModule: "",
  };

  const requests: Promise<RelatedResourceResponse>[] = [
    getRelatedMenuResourceList({ ...base, parentId: 0, module: "0" }),
    getRelatedMenuResourceList({
      ...base,
      parentId: null,
      parentName: "view_admin_center",
    }),
    ...AC_MENU_EXPAND_PARENT_NAMES.map((parentName) =>
      getRelatedMenuResourceList({
        ...base,
        parentId: null,
        parentName,
      })
    ),
  ];

  const results = await Promise.all(
    requests.map((p) => p.catch(() => ({ data: [] as string[] })))
  );

  return Array.from(new Set(results.flatMap(asNameList)));
}
